import Vue from "vue";

const STORAGE_KEY = "hb-transformer-locale";

export const i18nState = Vue.observable({
  locale: window.localStorage.getItem(STORAGE_KEY) || "zh-CN"
});

export function setLocale(locale) {
  i18nState.locale = locale;
  window.localStorage.setItem(STORAGE_KEY, locale);
}

export function pick(value, locale = i18nState.locale) {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    return value[locale] || value["zh-CN"] || "";
  }
  return value;
}

export function mapLocalizedList(items, locale = i18nState.locale) {
  return (items || []).map((item) => {
    if (typeof item === "string") {
      return item;
    }

    const mapped = {};
    Object.keys(item).forEach((key) => {
      mapped[key] = pick(item[key], locale);
    });
    return mapped;
  });
}

export default {
  computed: {
    locale() {
      return i18nState.locale;
    }
  },
  methods: {
    $pick(value) {
      return pick(value, i18nState.locale);
    },
    $setLocale(locale) {
      setLocale(locale);
    },
    $mapLocalizedList(items) {
      return mapLocalizedList(items, i18nState.locale);
    }
  }
};
